module.exports = __webpack_public_path__ + "static/the-myth-of-martyrdom-d004d666d7512e8ba5b7c2cb8a93d65b.jpg";